import React from "react";
import {AppBar, Container, Toolbar, Box, IconButton, Menu, MenuItem, Button, Typography} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/tombstoneGhost.png';
import bmc_logo from '../assets/bmc-logo.png';

const Navigation = () => {

    const NavItems = [
        {
            "name": '0x1 Home',
            "href": '/'
        },
        {
            "name": '0x2 Experience',
            "href": '/experience'
        },
        {
            "name": '0x3 Portfolio',
            "href": '/portfolio'
        },
        {
            "name": '0x4 Blogs',
            "href": '/blogs'
        },
        {
            "name": '0x5 Contact',
            "href": '/contact'
        },
    ]

    const Nav = () => {
        const [menuStatus, setMenuStatus] = React.useState(false);

        const handleNavMenu = () => {
            setMenuStatus(!menuStatus)
        };

        return (
            <div className="container-fluid">
                <AppBar position="fixed"
                        style={{backgroundColor: 'transparent'}}
                        elevation={0}>
                    <Container maxWidth="xl">
                        <Toolbar disableGutters style={{width: '100%'}}>
                            <div>
                                <a href="/">
                                    <img src={logo} alt="logo" style={{height: '80px', width: '80px'}}/>
                                </a>
                            </div>
                            <Box style={{justifyContent: 'right', background: 'transparent'}}
                                 sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                <IconButton
                                    onClick={handleNavMenu}
                                    color='inherit'>
                                    <MenuIcon />
                                </IconButton>
                                <Menu open={menuStatus} onClick={handleNavMenu}
                                      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                                      transformOrigin={{vertical: 'top', horizontal: 'right'}}>
                                    {NavItems.map(item => (
                                        <MenuItem key={item.name}>
                                            <Button
                                                key={item.name}
                                                sx={{ my: 2, color: 'white', display: 'block' }}>
                                                <a href={item.href}
                                                   style={{textDecoration: 'none', color: '#212121'}}>
                                                    {item.name}
                                                </a>
                                            </Button>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>
                            <Box style={{justifyContent: 'right'}}
                                sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                                {NavItems.map((item) => (
                                    <Button
                                        key={item.name}
                                        sx={{ my: 2, display: 'block' }}>
                                        <a href={item.href} style={{textDecoration: 'none', color: 'white'}}>
                                            <Typography variant='h6'>
                                                {item.name}
                                            </Typography>
                                        </a>
                                    </Button>
                                ))}
                            </Box>
                            <div className="ml-3 mr-2">
                                <a href="https://www.buymeacoffee.com/tombstoneghost" target="_blank"
                                   rel="noreferrer">
                                    <img src={bmc_logo} alt="logo" style={{height: '42px', width: '42px'}}/>
                                </a>
                            </div>
                        </Toolbar>
                    </Container>
                </AppBar>
            </div>
        )
    }

    return (
        <Nav/>
    )
}

export default Navigation;